export default "__VITE_ASSET__DoS4mlE2__"